import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { GrupoDespesaService } from '../services/grupo-despesa.service';
import { TipoDespesaService } from '../services/tipo-despesa.service';
import { TipoDespesaProdutoService } from '../services/tipo-despesa-produto.service';
import { CategoriaDespesaService } from '../services/categoria-despesa.service';
import { ProdutoService } from '../services/produto.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-tipos-despesa-edit',
	templateUrl: './tipos-despesa-edit.component.html',
	styleUrls: ['./tipos-despesa-edit.component.css'],
	animations: [loadingFade]
})
export class TiposDespesaEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public tipo_despesa_id = null;

	public formTipoDespesa: FormGroup;
	public grupo_despesa_array = []
	public categoria_despesa_array = []
	public produtos = []

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private grupoDespesaSvc: GrupoDespesaService,
				private categoriaDespesaSvc: CategoriaDespesaService,
				private router: Router,
				private tipoDespesaSvc: TipoDespesaService,
				private tipoDespesaPecaSvc: TipoDespesaProdutoService,
				private produtoSvc: ProdutoService,
				) { }

	ngOnInit() {
		this.criaForm();

		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.tipo_despesa_id = params.id;
				// pega dados a partir do id
				this.tipoDespesaSvc.getTipoDespesa(params.id).then((data: any) => {
					
					
					if(data.tipo_despesa_produto.length > 0){
						for(let peca of data.tipo_despesa_produto){
							this.addRow(peca.produto_id);
						}
					}
					else{
						data.tipo_despesa_produto = [{'produto_id': null}];
						this.addRow();
					}
				
					this.preencheForm(data);
					this.loading = false;
				});
			}
			else {
				this.addRow();
				
			}
		});

		this.loading = false;
	}

	criaForm() {
		this.formTipoDespesa = this.fb.group({
			tipo_despesa_id: null,
			tipo_despesa_nome: ['', Validators.required],
			grupo_despesa_id: [null, Validators.required],
			categoria_despesa_id: [null],
			tipo_despesa_periodo_aviso: '',
			tipo_despesa_km_aviso: '',
			tipo_despesa_produto: this.fb.array([])
		});

		this.pegaGruposDespesa();
		this.pegaCategoriasDespesa();
		this.pegaProdutos();
	}

	pegaGruposDespesa() {
		this.grupoDespesaSvc.getGruposDespesa('grupo_despesa_nome').then((data: any[]) => {
			this.grupo_despesa_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaCategoriasDespesa() {
		this.categoriaDespesaSvc.getCategoriasDespesa().then((data: any[]) => {
			this.categoria_despesa_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaProdutos() {
		this.produtoSvc.getProdutos().then((data: any[]) => {
			this.produtos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	preencheForm(dados) {
		this.formTipoDespesa.setValue(dados);
	}

	enviaTipoDespesa() {
		
		if (this.formTipoDespesa.valid) {
			this.submitting = true;

			let toSend = this.formTipoDespesa.value;
			if (this.tipo_despesa_id === null) { // criar
				this.tipoDespesaSvc.criaTipoDespesa(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Tipo de despesa cadastrado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/tiposdespesa']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.tipoDespesaSvc.editaTipoDespesa(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Tipo de despesa alterado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/tiposdespesa']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formTipoDespesa.controls){
				let campo = this.formTipoDespesa.get(field);
				campo.markAsTouched();
			  }
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formTipoDespesa.get(nome);
		return input.touched && input.invalid;
	}

	//***************************************
	// 			LISTAGEM DE PECAS
	//***************************************
	
	createItemDespesa(produto_id = null){
		return this.fb.group({
			produto_id: [produto_id, Validators.required]
		})
	}

	addRow(produto_id = null){
		const tipo_despesa_produto = this.formTipoDespesa.get('tipo_despesa_produto') as FormArray;
		if(produto_id != null){
			tipo_despesa_produto.push(this.createItemDespesa(produto_id));
		}
		else{
			tipo_despesa_produto.push(this.createItemDespesa());
		}
	}

	removeRow(index){
		const tipo_despesa_produto = this.formTipoDespesa.get('tipo_despesa_produto') as FormArray;
		tipo_despesa_produto.controls.length == 1 || tipo_despesa_produto.removeAt(index);
	}

	//***************************************
}
